module.exports = __webpack_public_path__ + "static/media/guest.27359188.svg";